"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.async-iterator");

require("core-js/modules/es.symbol.has-instance");

require("core-js/modules/es.symbol.is-concat-spreadable");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.symbol.match");

require("core-js/modules/es.symbol.replace");

require("core-js/modules/es.symbol.search");

require("core-js/modules/es.symbol.species");

require("core-js/modules/es.symbol.split");

require("core-js/modules/es.symbol.to-primitive");

require("core-js/modules/es.symbol.to-string-tag");

require("core-js/modules/es.symbol.unscopables");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.copy-within");

require("core-js/modules/es.array.every");

require("core-js/modules/es.array.fill");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.find-index");

require("core-js/modules/es.array.flat");

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.last-index-of");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.of");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.reduce-right");

require("core-js/modules/es.array.reverse");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.some");

require("core-js/modules/es.array.sort");

require("core-js/modules/es.array.species");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.array.unscopables.flat");

require("core-js/modules/es.array.unscopables.flat-map");

require("core-js/modules/es.array-buffer.constructor");

require("core-js/modules/es.array-buffer.is-view");

require("core-js/modules/es.array-buffer.slice");

require("core-js/modules/es.data-view");

require("core-js/modules/es.date.now");

require("core-js/modules/es.date.to-iso-string");

require("core-js/modules/es.date.to-json");

require("core-js/modules/es.date.to-primitive");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.bind");

require("core-js/modules/es.function.has-instance");

require("core-js/modules/es.function.name");

require("core-js/modules/es.json.to-string-tag");

require("core-js/modules/es.map");

require("core-js/modules/es.math.acosh");

require("core-js/modules/es.math.asinh");

require("core-js/modules/es.math.atanh");

require("core-js/modules/es.math.cbrt");

require("core-js/modules/es.math.clz32");

require("core-js/modules/es.math.cosh");

require("core-js/modules/es.math.expm1");

require("core-js/modules/es.math.fround");

require("core-js/modules/es.math.hypot");

require("core-js/modules/es.math.imul");

require("core-js/modules/es.math.log10");

require("core-js/modules/es.math.log1p");

require("core-js/modules/es.math.log2");

require("core-js/modules/es.math.sign");

require("core-js/modules/es.math.sinh");

require("core-js/modules/es.math.tanh");

require("core-js/modules/es.math.to-string-tag");

require("core-js/modules/es.math.trunc");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.epsilon");

require("core-js/modules/es.number.is-finite");

require("core-js/modules/es.number.is-integer");

require("core-js/modules/es.number.is-nan");

require("core-js/modules/es.number.is-safe-integer");

require("core-js/modules/es.number.max-safe-integer");

require("core-js/modules/es.number.min-safe-integer");

require("core-js/modules/es.number.parse-float");

require("core-js/modules/es.number.parse-int");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.number.to-precision");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-getter");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.define-setter");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.freeze");

require("core-js/modules/es.object.from-entries");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-own-property-names");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.is");

require("core-js/modules/es.object.is-extensible");

require("core-js/modules/es.object.is-frozen");

require("core-js/modules/es.object.is-sealed");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.lookup-getter");

require("core-js/modules/es.object.lookup-setter");

require("core-js/modules/es.object.prevent-extensions");

require("core-js/modules/es.object.seal");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.parse-float");

require("core-js/modules/es.parse-int");

require("core-js/modules/es.promise");

require("core-js/modules/es.promise.finally");

require("core-js/modules/es.reflect.apply");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.reflect.define-property");

require("core-js/modules/es.reflect.delete-property");

require("core-js/modules/es.reflect.get");

require("core-js/modules/es.reflect.get-own-property-descriptor");

require("core-js/modules/es.reflect.get-prototype-of");

require("core-js/modules/es.reflect.has");

require("core-js/modules/es.reflect.is-extensible");

require("core-js/modules/es.reflect.own-keys");

require("core-js/modules/es.reflect.prevent-extensions");

require("core-js/modules/es.reflect.set");

require("core-js/modules/es.reflect.set-prototype-of");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.flags");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.set");

require("core-js/modules/es.string.code-point-at");

require("core-js/modules/es.string.ends-with");

require("core-js/modules/es.string.from-code-point");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.pad-end");

require("core-js/modules/es.string.pad-start");

require("core-js/modules/es.string.raw");

require("core-js/modules/es.string.repeat");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.search");

require("core-js/modules/es.string.split");

require("core-js/modules/es.string.starts-with");

require("core-js/modules/es.string.trim");

require("core-js/modules/es.string.trim-end");

require("core-js/modules/es.string.trim-start");

require("core-js/modules/es.string.anchor");

require("core-js/modules/es.string.big");

require("core-js/modules/es.string.blink");

require("core-js/modules/es.string.bold");

require("core-js/modules/es.string.fixed");

require("core-js/modules/es.string.fontcolor");

require("core-js/modules/es.string.fontsize");

require("core-js/modules/es.string.italics");

require("core-js/modules/es.string.link");

require("core-js/modules/es.string.small");

require("core-js/modules/es.string.strike");

require("core-js/modules/es.string.sub");

require("core-js/modules/es.string.sup");

require("core-js/modules/es.typed-array.float32-array");

require("core-js/modules/es.typed-array.float64-array");

require("core-js/modules/es.typed-array.int8-array");

require("core-js/modules/es.typed-array.int16-array");

require("core-js/modules/es.typed-array.int32-array");

require("core-js/modules/es.typed-array.uint8-array");

require("core-js/modules/es.typed-array.uint8-clamped-array");

require("core-js/modules/es.typed-array.uint16-array");

require("core-js/modules/es.typed-array.uint32-array");

require("core-js/modules/es.typed-array.copy-within");

require("core-js/modules/es.typed-array.every");

require("core-js/modules/es.typed-array.fill");

require("core-js/modules/es.typed-array.filter");

require("core-js/modules/es.typed-array.find");

require("core-js/modules/es.typed-array.find-index");

require("core-js/modules/es.typed-array.for-each");

require("core-js/modules/es.typed-array.from");

require("core-js/modules/es.typed-array.includes");

require("core-js/modules/es.typed-array.index-of");

require("core-js/modules/es.typed-array.iterator");

require("core-js/modules/es.typed-array.join");

require("core-js/modules/es.typed-array.last-index-of");

require("core-js/modules/es.typed-array.map");

require("core-js/modules/es.typed-array.of");

require("core-js/modules/es.typed-array.reduce");

require("core-js/modules/es.typed-array.reduce-right");

require("core-js/modules/es.typed-array.reverse");

require("core-js/modules/es.typed-array.set");

require("core-js/modules/es.typed-array.slice");

require("core-js/modules/es.typed-array.some");

require("core-js/modules/es.typed-array.sort");

require("core-js/modules/es.typed-array.subarray");

require("core-js/modules/es.typed-array.to-locale-string");

require("core-js/modules/es.typed-array.to-string");

require("core-js/modules/es.weak-map");

require("core-js/modules/es.weak-set");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

require("core-js/modules/web.immediate");

require("core-js/modules/web.queue-microtask");

require("core-js/modules/web.timers");

require("core-js/modules/web.url");

require("core-js/modules/web.url.to-json");

require("core-js/modules/web.url-search-params");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReferenceField = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ContentList = _interopRequireDefault(require("../../ContentList/ContentList"));

var _FormControl = _interopRequireDefault(require("@civicplus/preamble/lib/FormControl/FormControl"));

var _InputLabel = _interopRequireDefault(require("@civicplus/preamble/lib/InputLabel/InputLabel"));

var _Typography = _interopRequireDefault(require("@civicplus/preamble/lib/Typography"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("@civicplus/preamble/lib/ErrorHandlingFormHelperText/ErrorHandlingFormHelperText"));

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _Dialog = _interopRequireDefault(require("@civicplus/preamble/lib/Dialog"));

require("regenerator-runtime/runtime");

var ReferenceField = function ReferenceField(props) {
  var _props$value;

  var classes = props.classes || {};

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedContentItems = _useState2[0],
      setSelectedContentItems = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      ref = _useState4[0],
      setRef = _useState4[1];

  var _useState5 = (0, _react.useState)((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : []),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      referenceIds = _useState6[0],
      setReferenceIds = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      initialized = _useState8[0],
      setInitialized = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      openModal = _useState10[0],
      setOpenModal = _useState10[1];

  (0, _react.useEffect)(function () {
    // Workaround to not call onChange immediately when component renders.
    if (initialized) {
      var _props$onChange;

      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, {
        target: {
          value: referenceIds
        }
      });
    }

    if (!initialized) {
      setInitialized(true);
    }

    if (ref) {
      ref.refreshListing();
    } // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [referenceIds]);

  function buildContentList() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        ids = _ref.ids,
        onRef = _ref.onRef,
        _ref$isModal = _ref.isModal,
        isModal = _ref$isModal === void 0 ? false : _ref$isModal;

    var pagination = isModal ? {
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 25, 50, 100]
    } : undefined;
    var actions = isModal ? undefined : [{
      display: "Unlink Item",
      action: function action(items) {
        var toRemove = new Set(items.map(function (w) {
          return w.id;
        }));
        var newIds = referenceIds.filter(function (w) {
          return !toRemove.has(w);
        });

        if (ref) {
          ref.unselectAllRows();
        }

        setReferenceIds(newIds);
      }
    }];

    if (!props.schema) {
      return /*#__PURE__*/_react["default"].createElement("p", null, "You have not configured a schema for your reference field, please add a schema to link content for under field validation on the content management system.");
    }

    return /*#__PURE__*/_react["default"].createElement(_ContentList["default"], {
      key: "reference-content-list",
      className: "prmbl-reference-toSelectList",
      id: "".concat(props.id, "-references-to-select"),
      config: props.config,
      actions: actions,
      emptyState: "You do not have any records linked.",
      onSelect: function onSelect(selected) {
        setSelectedContentItems(selected);
      },
      pagination: pagination,
      selectableRows: "multiple",
      enablePreload: false,
      onRef: onRef,
      compact: true,
      filterByIds: ids,
      schema: props.schema
    });
  }

  var rootLabelProps = {
    id: props.id,
    disabled: props.disabled,
    shrink: false
  };

  var cancelButton = /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    key: "cancel",
    id: "".concat(props.schema, "-modal-cancel"),
    onClick: function onClick() {
      setOpenModal(false);
    }
  }, "Cancel");

  var confirmButton = /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    key: "ok",
    id: "".concat(props.schema, "-modal-ok"),
    onClick: function onClick() {
      var ids = Array.from(new Set(referenceIds.concat(selectedContentItems.map(function (w) {
        if (w.id) {
          return w.id;
        } else {
          throw new Error("Content item missing ID");
        }
      }))));
      setReferenceIds(ids);
      setSelectedContentItems([]);
      setOpenModal(false);
    }
  }, "Link Selected Items");

  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    id: props.id,
    className: "prmbl-reference ".concat(props.className),
    disabled: props.disabled,
    error: props.error,
    required: true,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])("prmbl-reference-label", classes.referenceLabel)
  }, rootLabelProps), props.label), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("prmbl-referenceWrapper", classes.wrapper)
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    gutterBottom: true
  }), !props.disabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: (0, _classnames["default"])("prmbl-reference-linkContent"),
    onClick: function onClick() {
      return setOpenModal(true);
    }
  }, "Link Content"), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    className: "prmbl-referenceModal",
    actions: [cancelButton, confirmButton],
    id: "".concat(props.schema, "-modal"),
    open: openModal,
    title: "Select Items",
    onClose: function onClose() {
      return setOpenModal(false);
    },
    maxWidth: false,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("prmbl-referenceWrapper"),
    style: {
      marginTop: "1.5em"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, buildContentList({
    isModal: true
  })), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    gutterBottom: true
  })))), referenceIds.length > 0 && buildContentList({
    ids: referenceIds,
    onRef: setRef
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    gutterBottom: true
  })), /*#__PURE__*/_react["default"].createElement(_ErrorHandlingFormHelperText["default"], {
    id: "error-handler-text-" + props.id,
    helperText: props.helperText,
    error: props.error,
    errorMessage: props.errorMessage
  }));
};

exports.ReferenceField = ReferenceField;
var _default = ReferenceField;
exports["default"] = _default;